export const SET_NEW_CONVERSATION_ID = 'SET_NEW_CONVERSATION_ID'
